/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'right': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.301 23.189',
    data: '<defs/><g id="right" transform="translate(-1161.999 -3229)"><path pid="0" id="path" class="cls-1" d="M14.3 2.705l-8.889 8.89 8.889 8.889-2.705 2.706L0 11.595 11.595 0z" transform="rotate(180 588.15 1626.095)"/></g>'
  }
})
